import type { ForgotPasswordRequest, LoginRequest, LoginResponse, ResetCurrentUserPasswordRequest, ResetPasswordRequest } from '@/models/auth';
import AxiosFactory from '@/services/axiosFactory';
import type { AxiosResponse } from 'axios';

export default class AuthService {
    private client = AxiosFactory.create({
        baseURL: '/api/v1/auth/'
    });

    public async Login(request: LoginRequest): Promise<AxiosResponse<LoginResponse>> {
        return (await this.client).post('login', request);
    }

    public async Logout(): Promise<AxiosResponse<void>> {
        return (await this.client).post('logout').then((res) => res);
    }

    public async ForgotPassword(request: ForgotPasswordRequest): Promise<AxiosResponse<void>> {
        return (await this.client).post('forgotpassword', request);
    }
    public async ResetPassword(request: ResetPasswordRequest): Promise<AxiosResponse<void>> {
        return (await this.client).post('resetpassword', request);
    }
    public async ResetPasswordForCurrentUser(request: ResetCurrentUserPasswordRequest): Promise<AxiosResponse<void>> {
        return (await this.client).post('resetpasswordforcurrentmember', request);
    }
}
